/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScimUsageStatResource
 */
export interface ScimUsageStatResource {
    /**
     * 
     * @type {number}
     * @memberof ScimUsageStatResource
     */
    userCreated: number;
}

/**
 * Check if a given object implements the ScimUsageStatResource interface.
 */
export function instanceOfScimUsageStatResource(value: object): value is ScimUsageStatResource {
    if (!('userCreated' in value) || value['userCreated'] === undefined) return false;
    return true;
}

export function ScimUsageStatResourceFromJSON(json: any): ScimUsageStatResource {
    return ScimUsageStatResourceFromJSONTyped(json, false);
}

export function ScimUsageStatResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScimUsageStatResource {
    if (json == null) {
        return json;
    }
    return {
        
        'userCreated': json['userCreated'],
    };
}

export function ScimUsageStatResourceToJSON(value?: ScimUsageStatResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userCreated': value['userCreated'],
    };
}

